var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-modal',_vm._b({ref:"modal",attrs:{"footer":_vm.footer,"visible":_vm.visible,"dialogClass":"transparent","wrapClassName":"custom-modal","dialogStyle":{
      padding:0,
      backgroundColor: 'transparent',
    },"bodyStyle":{
      padding:0,
      marginTop: 30,
      backgroundColor: 'transparent',
    }},on:{"cancel":function($event){return _vm.$emit('cancel', $event)}},scopedSlots:_vm._u([{key:"closeIcon",fn:function(){return undefined},proxy:true}])},'a-modal',_vm.$attrs,false),[_vm._v(" "),_c('dd-header-card',{attrs:{"header":_vm.title}},[_vm._t("content",[_c('p',[_vm._v(_vm._s(_vm.description))])]),_vm._v(" "),_c('div',{staticClass:"flex-row gap-md justify-content-end align-items-center"},[_vm._t("buttons")],2)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }